import React, { useState, useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as Yup from 'yup'
import { Formik, Form } from 'formik'
import {
  promotional_text_published,
  promotional_text_approved,
  promotional_text_updated,
} from '../constants'
import Loader from '../../../components/Loader'
import { get, post } from '../../../lib/api'
import { Stats, Timer } from './monthlyBookCard'
import { menuItemObj } from '../../../components/PrivatePage'
import { Box, Text, Image, Button } from '../../../designSystem'
import { AccountContext } from '../../../providers/accountProvider'
import AlertSnackBar from '../../../components/AlertSnackBar'
import {
  wbpBookCard,
  wbpThumbnail,
  wbpDetails,
  title,
  ctaBox,
  descriptionCard,
  descriptionText,
  bottomCardSection,
  bookProgressBar,
  wordsProgress,
  ProgressDivInner,
  BookAction,
  statsHolder,
  actionWhiteButton,
  progressDivOuter,
  AuthorName,
  SubTitle,
  ArrowWhite,
  ActionBox,
  MailLink,
} from '../style'
import { Popup } from '../../../components/Popup'
import { SearchableSingleSelectDropdown } from '../../../components/FormikInputs'
import { countryList } from '../../../constants'
import { checkOverseasUser, emailContentGenerator } from '../../../lib/utils'
import { handleNewEventLog } from '../../../lib/utils/events'

const BookCard = ({
  resetAfterUnblock,
  history,
  book,
  totalBooks,
  novelApply,
  viewApplication,
  isMobile,
  signingStatus,
}) => {
  const [isPublishLoading, setIsPublishLoading] = useState(false)
  const [isUnlockProcessing, setUnlockProcessing] = useState(false)
  const [isCountryPopupOpen, toggleCountryPopup] = useState(false)
  const [applySnack, toggleApplySnack] = useState(false)
  const { user, onUpdateUser } = useContext(AccountContext)
  const profileName = user.fullname || ' '
  const isNonIndianAndNonUSUser =
    checkOverseasUser(user) && user.location !== 'US'
  const isPublished = book.status === 'published' || book.status === 'approved'
  const isNotApplied = book.application_status === 'not_applied'
  const isCreated = book.application_status === 'created'
  const isEligible = book.application_status === 'eligible'
  const isPending = book.application_status === 'pending'
  const isRejected = book.application_status === 'rejected'
  const isTerminated = book.application_status === 'termination'
  const isCompleted = book.application_status === 'completion'
  const isUpdated = book.application_status === 'updated'
  const isApproved = book.application_status === 'approved'
  const isReapplied = book.application_status === 'reapplied'
  const isDisabled = book.status === 'disabled'
  const isDraft = book.status === 'draft'
  const publishTime = book.publish_time
  const unPublishedByCMS = isDraft && publishTime
  const isLanguageNotAllowedForWBP = !['hindi', 'tamil', 'english'].includes(
    book.language
  )
  const dateCheck = new Date(book.create_time) - new Date(2022, 7, 2) >= 0
  const isWBPBlocked =
    isPublished &&
    !(isPending || isApproved || isRejected) &&
    isLanguageNotAllowedForWBP
  const mailContentForFlaggedBook = emailContentGenerator(
    user,
    book.book_id,
    'Query/Compliant against flagged content',
    'Kindly write your detailed query/complaint below and attach proof of original fiction if falsely flagged by us.'
  )
  const mailContentForDisableBook = emailContentGenerator(
    user,
    book.book_id,
    'Query/Compliant against disabled content',
    'Kindly write your detailed query/compliant below and attach proof of original fiction if falsely disabled by us.'
  )
  const flaggedText = (
    <>
      {' '}
      This book has been flagged due to unusual behavior on request from
      readers, Please note we only support books with non-sensitive original &
      fiction content with a proper storyline.
      <br /> If any concerns, please reach out to us at{' '}
      <MailLink href={mailContentForFlaggedBook}>
        writers@pocketfm.com
      </MailLink>{' '}
      .
    </>
  )

  useEffect(() => {
    if (book?.daily_tracker?.chapter_missed) {
      handleNewEventLog(
        'home',
        `writer_home_add_todays_chapter_cta_viewed`,
        {
          route: window.location.pathname + window.location.search,
          module_name: 'home_novel_module',
          button: 'add_todays_chapter'
        },
        user,
        book
      )
    }
    if(isPublished && isNotApplied){
      handleNewEventLog(
        'home',
        `writer_home_complete_30k_words_cta_viewed`,
        {
          route: window.location.pathname + window.location.search,
          module_name: 'home_novel_module',
          button: 'complete_30k_words'
        },
        user,
        book
      )
    }
    if(!isPublished && isNotApplied && !isDisabled && !publishTime){
      handleNewEventLog(
        'home',
        `writer_home_publish_your_novel_cta_viewed`,
        {
          route: window.location.pathname + window.location.search,
          module_name: 'home_novel_module',
          button: 'publish_your_novel'
        },
        user,
        book
      )
    }
  },[])

  const handlePublishClick = async () => {
    if (isPublishLoading) return
    handleNewEventLog('home','writer_home_publish_your_novel_cta_clicked',{route : window.location.pathname + window.location.search, button : 'publish_your_novel'}, user, book)
    setIsPublishLoading(true)
    let getDetailsBeforePublish = false
    // TODO: disucss if throw error and not procees if details fetch api fails,
    // which might lead to wrong flag sent to chapter open page
    const detailsRes = await get('/content_api/book.novel_details', {
      params: {
        book_id: book.book_id,
        view: 'dashboard',
        is_novel: 1,
      },
    })
    const { results } = detailsRes
    const hasRequiredBookDetails =
      results.image_url &&
      results.description &&
      results.book_title &&
      results.category_obj &&
      results.category_obj.topic_id
    if (!hasRequiredBookDetails) {
      getDetailsBeforePublish = true
    }
    get('/content_api/book.chapters_by_status', {
      params: {
        page_no: 1,
        book_id: book.book_id,
        status: 'draft',
        view: 'dashboard',
        is_novel: 1,
      },
    })
      .then((response) => {
        setIsPublishLoading(false)
        const firstChapter = response.results.chapters[0] || {}
        const { chapter_id } = firstChapter
        if (chapter_id) {
          history.push(
            `${menuItemObj.novels}/edit-chapter/${
              book.book_id
            }?chapter_id=${chapter_id}&proceed_to_details=${
              getDetailsBeforePublish ? '1' : ''
            }&redirect_to_home=1`
          )
        } else {
          history.push(`${menuItemObj.novels}/id/${book.book_id}?tab=draft`)
        }
      })
      .catch((error) => {
        setIsPublishLoading(false)
        throw error
      })
  }

  const handleUnlockReward = () => {
    if (isUnlockProcessing) return
    const { program_id } = book
    if (!program_id) return
    setUnlockProcessing(true)
    post('/content_api/book.rewards_unlock?is_novel=1', {
      data: {
        program_id,
      },
    })
      .then(() => {
        setUnlockProcessing(false)
        resetAfterUnblock()
      })
      .catch((error) => {
        setUnlockProcessing(false)
        throw error
      })
  }
  const handleApplyNow = () => {
    if (
      book.word_count >= 50000 &&
      !(book.status === 'approved' || book.status === 'published')
    ) {
      toggleApplySnack(true)
      return
    }
    if (book.is_eligible) {
      if (
        user?.location == null ||
        user?.location === '' ||
        user?.location?.length > 2
      ) {
        toggleCountryPopup(true)
      } else {
        novelApply(book.book_id)
      }
    }
  }

  const ActionBoxes = () => (
    <Box {...ctaBox}>
      {!isPublished && isNotApplied && !isDisabled && !publishTime && (
        <BookAction onClick={handlePublishClick} enabled={1}>
          {!isPublishLoading ? (
            <>
              {user?.location === 'US'
                ? 'Publish Your Series'
                : 'Publish Your Novel'}{' '}
              {isMobile && <ArrowWhite />}
            </>
          ) : (
            <Loader invertColor inline size="sm" />
          )}
        </BookAction>
      )}
      {
        // added below buttom condition for Our Business Logic  Condition
        !isDraft &&
          (isNonIndianAndNonUSUser ||
            isWBPBlocked ||
            (isPublished &&
              isPending &&
              book.word_count >= (book?.application_threshold || 30000))) && (
            <BookAction
              onClick={() =>
                history.push(
                  `${menuItemObj.novels}/id/${book.book_id}?tab=draft`
                )
              }
              enabled={1}
            >
              Add New Chapter {isMobile && <ArrowWhite />}
            </BookAction>
          )
      }
      {/* remove below button condition for Our Business Logic Condition */}
      {!isLanguageNotAllowedForWBP &&
        !isNonIndianAndNonUSUser &&
        isPublished &&
        ((isNotApplied && !book.is_eligible) ||
          (isPending &&
            book.word_count < (book?.application_threshold || 30000)) ||
          isCreated) && (
          <BookAction
            onClick={() =>
              {
                handleNewEventLog(
                  'home',
                  `writer_home_complete_30k_words_cta_clicked`,
                  {
                    route: window.location.pathname + window.location.search,
                    module_name: 'home_novel_module',
                    button: `complete_${book.application_threshold}_words`
                  },
                  user,
                  book
                )
                history.push(`${menuItemObj.novels}/id/${book.book_id}?tab=draft`)
              }
            }
            enabled={1}
          >
            {`Complete ${book.application_threshold} words`}
            {isMobile && <ArrowWhite />}
          </BookAction>
        )}
      {!isMobile &&
        isPublished &&
        isPending &&
        book.word_count >= (book?.application_threshold || 30000) && (
          <Box
            {...actionWhiteButton}
            onClick={() => viewApplication(book.book_id)}
          >
            View Application
          </Box>
        )}
      {isPublished && isApproved && (
        <BookAction
          onClick={() => (isUnlockProcessing ? null : handleUnlockReward())}
          enabled={1}
        >
          {!isUnlockProcessing ? (
            <>
              Accept and Unlock Rewards
              <ArrowWhite />
            </>
          ) : (
            <Loader invertColor inline size="sm" />
          )}
        </BookAction>
      )}

      {isPublished &&
        (isRejected || isUpdated || isTerminated || isCompleted) && (
          <BookAction
            enabled={1}
            onClick={() => history.push('/shows/novels/?open-new=1')}
          >
            {user?.location === 'US' ? 'Create New Series' : 'Create New Novel'}{' '}
            {isMobile && <ArrowWhite />}
          </BookAction>
        )}
      {isEligible && (
        <BookAction
          enabled={1}
          onClick={() =>
                history.push(
                `${menuItemObj.novels}/id/${book.book_id}?tab=draft`
                )
              }
        >
          {book?.daily_tracker?.chapter_missed
            ? 'Add Today’s Chapter'
            : 'Add New Chapter'}
        </BookAction>
      )}
    </Box>
  )

  const BookProgressBar = () => {
    if (!isPublished) return null
    if (isLanguageNotAllowedForWBP) return null
    if (isNonIndianAndNonUSUser) return null
    if (
      (isPending || isApproved) &&
      book.word_count > (book?.application_threshold || 30000)
    )
      return null
    return (
      <Box {...bottomCardSection}>
        <Box {...bookProgressBar}>
          <Box {...wordsProgress}>
            {book.word_count || 0} / {book.application_threshold}
          </Box>
          <Box {...progressDivOuter}>
            <ProgressDivInner
              width={
                (book.word_count / book.application_threshold) * 100 > 100
                  ? 100
                  : (book.word_count / book.application_threshold) * 100
              }
            />
          </Box>
        </Box>
        {(isNotApplied || isReapplied || isCreated || isEligible) && (
          <BookAction
            onClick={handleApplyNow}
            enabled={book.is_eligible && !isCreated}
          >
            {isCreated || isEligible ? 'Submit Details' : 'Apply Now'}
          </BookAction>
        )}
      </Box>
    )
  }

  const StatsComponent = () => {
    if (isPublished && (isPending || isApproved || isRejected))
      return (
        <Box {...statsHolder}>
          <Stats
            views={book.stats.total_views}
            chapters={book.chapters_count}
            words={book.word_count}
            likes={book.stats.likes}
            comments={book.stats.comments}
          />
        </Box>
      )
    return null
  }

  const CautionTextWrapper = (props) => (
    <Box {...descriptionCard}>
      <Text {...descriptionText}>{props.children}</Text>
    </Box>
  )

  const CautionText = ()=> {
    if (book?.day_zero_incentive_eligible && isPending) {
      return <>
        {signingStatus === 'applied' && <CautionTextWrapper>Thank you for submitting your details . <span style={{color: 'blue', cursor: 'pointer'}} onClick={() => history.push(`shows/novels/id/${book.book_id}?tab=draft`)}>Sign Contract</span> & start receiving the generated incentives.</CautionTextWrapper>}
        {(!signingStatus || signingStatus !== 'applied')  && <CautionTextWrapper>Contract process is in review. All incentives will be transferred to you, by the 2nd week of subsequent Month post-contract confirmation.</CautionTextWrapper>}
      </>
    }
    return (
      <>
        {isDisabled && (
          <CautionTextWrapper>
            This book has been disabled on request from the author or readers.
            Please note we only support books with non-sensitive original &
            fiction content with a proper storyline. If any concerns, please
            reach out to us at{' '}
            <MailLink href={mailContentForDisableBook}>
              writers@pocketfm.com
            </MailLink>{' '}
            . Repeat strikes could lead to the account being blocked.
          </CautionTextWrapper>
        )}
        {unPublishedByCMS && (
          <CautionTextWrapper>{flaggedText}</CautionTextWrapper>
        )}
        {!isPublished && isNotApplied && !isDisabled && !publishTime && (
          <CautionTextWrapper>
            <strong>
              {book?.is_novel === 2
                ? 'Publish atleast 1 chapter to get it live on Pocket fm '
                : 'Publish atleast 1 chapter to get it live on Pocket Novels app'}
            </strong>
          </CautionTextWrapper>
        )}
        {!isLanguageNotAllowedForWBP &&
          !isNonIndianAndNonUSUser &&
          isPublished &&
          isNotApplied &&
          !book.is_eligible && (
            <CautionTextWrapper>
              {' '}
              {promotional_text_published.replace(
                '{{amount}}',
                user?.author_visibility === 'india'
                  ? `${book.application_threshold}`
                  : `${
                      book.application_threshold === 15000 ? '15,000' : '30,000'
                    }`
              )}{' '}
            </CautionTextWrapper>
          )}
        {!isLanguageNotAllowedForWBP &&
          !isNonIndianAndNonUSUser &&
          isPublished &&
          isNotApplied &&
          book.is_eligible && (
            <CautionTextWrapper>
              <strong>Congratulations on publishing your novel. </strong>You’re
              now eligble to apply for the Writer’s Benefit Program.
            </CautionTextWrapper>
          )}
        {isCreated && (
          <CautionTextWrapper>
            Congratulations on publishing your novel. Write 30000 words to
            submit contract details & start receiving the generated incentives
          </CautionTextWrapper>
        )}
        {isEligible && (
          <CautionTextWrapper>
            Almost there, Submit contract details to start receiving the
            generated incentives
          </CautionTextWrapper>
        )}
        {!isNonIndianAndNonUSUser &&
          isPublished &&
          isPending &&
          (book.word_count >= (book?.application_threshold || 30000) ? (
            <CautionTextWrapper>
              Your application is under review. Meanwhile, keep adding more
              chapters to get more readers which will help us evaluate your
              novel earliest. Please note: Only <strong> Top 10% </strong> of
              the application gets selected for the writer&apos;s benefits
              program & It might take us 1 month or more to process.
              {isMobile && (
                <Box
                  onClick={() => viewApplication(book.book_id)}
                  color="interactive.azure2"
                >
                  VIEW YOUR APPLICATION
                </Box>
              )}
            </CautionTextWrapper>
          ) : (
            <CautionTextWrapper>
              <strong>
                Thank you for applying for wbp program, it will be reviewed once
                you complete 30,000 Words .
              </strong>
            </CautionTextWrapper>
          ))}
        {isPublished && isRejected && (
          <CautionTextWrapper>
            Currently, we cannot sign your novel as it doesn’t meet our minimum
            performance guidelines or editorial feedback.
            {book?.is_novel === 2 ? (
              <>
                You can start a new novel, and again apply for the Writer
                Benefits Program. All the best!
              </>
            ) : (
              <>
                {' '}
                You can refer to your novel’s engagement data vs Novels in the
                Program{' '}
                <span
                  style={{ color: 'blue', cursor: 'pointer' }}
                  onClick={() =>
                    history.push(`/analytics?bookId=${book.book_id}`)
                  }
                >
                  here
                </span>
                .
              </>
            )}
          </CautionTextWrapper>
        )}
        {isPublished && isTerminated && (
          <CautionTextWrapper>
            Thank you for adding your book to the Writer Benefit Program, We
            have decided to end the book from the writer benefit program as the
            retention is not up to expectation. You can refer to your novel’s
            engagement data vs Novels in the Program{' '}
            <span
              style={{ color: 'blue', cursor: 'pointer' }}
              onClick={() => history.push(`/analytics?bookId=${book.book_id}`)}
            >
              here
            </span>{' '}
            . We are eagerly waiting for your next novel. Best Wishes.{' '}
          </CautionTextWrapper>
        )}
        {isPublished && isCompleted && (
          <CautionTextWrapper>
            {user.location === 'US'
              ? 'Thank you for successfully adding your book through the Writer Benefit Program, we are eagerly waiting for your next series.'
              : 'Thank you for successfully adding your book through the Writer Benefit Program, we are eagerly waiting for your next novel.'}{' '}
          </CautionTextWrapper>
        )}
        {isPublished && isUpdated && promotional_text_updated}
        {!isNonIndianAndNonUSUser && isPublished && isApproved && (
          <CautionTextWrapper>
            {' '}
            {promotional_text_approved.replace(
              '{{amount}}',
              user?.author_visibility === 'india' ? 'Rs 5000' : '$300'
            )}{' '}
          </CautionTextWrapper>
        )}
        {!isNonIndianAndNonUSUser && isPublished && isReapplied && (
          <CautionTextWrapper>
            You can again apply to the Writer’s Benefit Program after completing
            100,000 words on the basis of editorial feedback
          </CautionTextWrapper>
        )}
      </>
    )
  }

  const DesktopView = () => (
    <>
      {/* {!is_program_user && totalBooks < 2 && <HR />} */}
      {totalBooks !== 0 && (
        <Box display="flex" alignItems="center">
          <Box
            {...wbpThumbnail}
            onClick={() =>
              history.push(`${menuItemObj.novels}/id/${book.book_id}?tab=draft`)
            }
          >
            {book.image_url && (
              <Image
                width={['44px', '112px']}
                height={['66px', '168px']}
                src={book.image_url}
              />
            )}
          </Box>
          <Box {...wbpDetails}>
            <Box>
              <Text {...title}>
                {!isNonIndianAndNonUSUser &&
                  !isPublished &&
                  isNotApplied &&
                  !isLanguageNotAllowedForWBP &&
                  'Next Step - Publish your novel'}
                {!isNonIndianAndNonUSUser &&
                  isPublished &&
                  isNotApplied &&
                  !isLanguageNotAllowedForWBP &&
                  !book.is_eligible &&
                  (user?.author_visibility === 'india'
                    ? `Next Step - Complete ${book.application_threshold} Words`
                    : 'Next Step - Complete 30,000 Words')}
                {!isNonIndianAndNonUSUser &&
                  isPublished &&
                  (isNotApplied || isReapplied) &&
                  !isLanguageNotAllowedForWBP &&
                  book.is_eligible &&
                  dateCheck &&
                  'Next Step - Apply for the Writer’s Benefit Program'}
                {isPublished && isPending && 'Your Application is submitted'}
                {isPublished && isRejected && 'Your Application is Rejected'}
                {isPublished && isUpdated && 'Your Application is Updated'}
                {isPublished && isApproved && 'Your Application is Approved'}
                {isPublished &&
                  isReapplied &&
                  'Next Step - Complete 100,000 Words'}
              </Text>
            </Box>
            <SubTitle>{book.book_title}</SubTitle>
            <AuthorName>{profileName}</AuthorName>
            <ActionBoxes />
            {book?.daily_tracker?.chapter_missed && <Timer />}
          </Box>
        </Box>
      )}
      <CautionText />
      {(isNotApplied || isCreated || isEligible) && <BookProgressBar />}
      <StatsComponent />
    </>
  )

  const MobileView = () => (
    <>
      {/* {!is_program_user && totalBooks < 2 && <HR />} */}
      {totalBooks !== 0 && (
        <Box display="flex" alignItems="center">
          <Box
            {...wbpThumbnail}
            onClick={() =>
              history.push(`${menuItemObj.novels}/id/${book.book_id}?tab=draft`)
            }
          >
            {book.image_url && (
              <Image
                width={['44px', '112px']}
                height={['66px', '168px']}
                src={book.image_url}
              />
            )}
          </Box>
          <Box {...wbpDetails}>
            <SubTitle>{book.book_title}</SubTitle>
            <AuthorName>{profileName}</AuthorName>
          </Box>
        </Box>
      )}
      {book?.daily_tracker?.chapter_missed && <Timer />}
      <ActionBoxes />
      {(isNotApplied || isCreated || isEligible) && <BookProgressBar />}
      {book?.book_id && <CautionText />}
      <StatsComponent />
    </>
  )

  return (
    <Box {...wbpBookCard} key={book.book_id}>
      <Popup
        show={isCountryPopupOpen}
        close={() => toggleCountryPopup(false)}
        renderActions={<></>}
      >
        <Text variant="heading">
          Select Nationality first, to proceed with Writer Benefit Application
        </Text>
        <Formik
          initialValues={{
            country: user?.location?.length > 2 ? '' : user?.location,
          }}
          validationSchema={Yup.object({
            country: Yup.string().required('Required'),
          })}
          onSubmit={(values) => {
            post('/user_api/user.update?is_novel=1', {
              data: { location: values.country },
            }).then(() => {
              toggleCountryPopup(false)
              onUpdateUser({ ...user, location: values.country })
              novelApply(book.book_id)
            })
          }}
        >
          {({ isSubmitting }) => (
            <Form>
              <Box my={8}>
                <SearchableSingleSelectDropdown
                  label="Country"
                  name="country"
                  selectKey="code"
                  nameKey="name"
                  placeholder="Type to Search"
                  valueArray={countryList}
                  notAbsolutePosition
                />
              </Box>
              <ActionBox>
                <Button
                  variant="outlinePrimary"
                  onClick={() => toggleCountryPopup(false)}
                >
                  Cancel{' '}
                </Button>
                {!isSubmitting && (
                  <Button
                    ml={8}
                    variant="fillPrimary"
                    width={['100%', 'unset']}
                    type="submit"
                  >
                    Save Nationality
                  </Button>
                )}
                {isSubmitting && (
                  <Button type="button">
                    <Loader invertColor inline size="sm" />
                  </Button>
                )}
              </ActionBox>
            </Form>
          )}
        </Formik>
      </Popup>

      {isMobile && <MobileView />}
      {!isMobile && <DesktopView />}

      {applySnack && (
        <AlertSnackBar
          close={() => toggleApplySnack(false)}
          text="Sorry, the book doesn't match the editorial guidelines of the platform"
        />
      )}
    </Box>
  )
}

export default withRouter(BookCard)
